import {
    AbstractControlOptions,
    AsyncValidatorFn,
    FormControl,
    ValidatorFn,
} from '@angular/forms';

export class LabeledFormControl extends FormControl {
    public label: string;
    public display: Function;

    constructor(
        label: string,
        formState?: any,
        validatorOrOpts?:
            | ValidatorFn
            | ValidatorFn[]
            | AbstractControlOptions
            | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
        displayFn?: Function
    ) {
        super(formState, validatorOrOpts, asyncValidator);
        this.label = label;
        this.display = displayFn;
    }
}
